import React from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

const TechnicalDetailMakeTitle = ({makeUrlParam, makeName, i18n, domain}) => {
  const config = domain.get('config')
  const urlStatics = config.get('URL_MAKES_IMAGES')
  const imageUrl = ({makeUrlParam}) => `${urlStatics}${makeUrlParam}.jpg`
  const makeTitle = i18n.t('TECHNICAL_DETAILS_MAKE_TITLE', {
    make: makeName,
    highlightStart: `<strong class='mt-TechnicalDetailMakeTitle-titleMake'>`,
    highlightEnd: '</strong>'
  })

  return (
    <div className="mt-TechnicalDetailMakeTitle">
      <div className="mt-TechnicalDetailMakeTitle-imageWrapper">
        <AtomImage src={imageUrl({makeUrlParam})} alt={makeName} />
      </div>
      <h1 className="mt-TechnicalDetailMakeTitle-title">{htmlStringToReactElement(makeTitle)}</h1>
    </div>
  )
}

TechnicalDetailMakeTitle.propTypes = {
  makeUrlParam: PropTypes.string.isRequired,
  makeName: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired
}

export default Context.wrapper(TechnicalDetailMakeTitle, 'TechnicalDetailMakeTitle')
